import { render, staticRenderFns } from "./QuestionAttachments.vue?vue&type=template&id=488cd3e0"
import script from "./QuestionAttachments.vue?vue&type=script&lang=js"
export * from "./QuestionAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports